<script>
import Olympics from '../index';
export default {
  extends: Olympics,
  computed: {
    placeName() {
      return '第三期';
    },
    ruleLink() {
      return '/teacher/house/rules';
    }
  },
  methods: {
    async initPermission() {
      await this.$login.teacherPermitted();
    }
  }
};
</script>
